export const countryCode = {
  CN: "China",
  KR: "Korea",
  RU: "Russia",
};
